import React, { useState, useEffect } from "react";
import SelectInput from "../formComp/SelectInputOld";
import TextInput from "../formComp/TextInputOld";
import BlueCard from "../formComp/BlueCardOld";
import {
  CrownBridgeForm,
  CrownBridgeProps,
  CrownBridgeOutput,
} from "../../../types/BlueCardTypes";

const CrownBridge: React.FC<CrownBridgeProps> = ({ onChange, filterToken }) => {
  const [cards, setCards] = useState<CrownBridgeForm[]>([
    {
      toothNumbers: [],
      material: "",
      prosthesisType: "",
      designType: "",
      shade: "",
    },
  ]);

  const [occlusalContact, setOcclusalContact] = useState("");
  const [proximalContact, setProximalContact] = useState("");
  const [ponticDesign, setPonticDesign] = useState("");

  const handleCardChange = (
    index: number,
    field: string,
    value: string | string[]
  ) => {
    setCards((prev) =>
      prev.map((card, i) => (i === index ? { ...card, [field]: value } : card))
    );
  };

  const handleAddCard = () => {
    setCards((prev) => [
      ...prev,
      {
        toothNumbers: [],
        material: "",
        prosthesisType: "",
        designType: "",
        shade: "",
      },
    ]);
  };

  const handleRemoveCard = (index: number) => {
    setCards((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    const output: CrownBridgeOutput = {
      occlusalContact,
      proximalContact,
      ponticDesign,
      instanceDetails: cards,
    };
    onChange(output);
  }, [cards, occlusalContact, proximalContact, ponticDesign, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="tracking-tight font-bold mb-4 border-b-2 border-[#2fa9bf]">
        CROWN & BRIDGE
      </h2>

      {cards.map((card, index) => (
        <div
          key={index}
          className={`w-full relative ${index > 0 ? "mt-4" : ""}`}
        >
          {index > 0 && (
            <button
              type="button"
              onClick={() => handleRemoveCard(index)}
              className="absolute top-0 md:top-1 right-0 md:right-2 text-red-500 text-sm md:text-[20px] font-bold"
            >
              ✕
            </button>
          )}
          <BlueCard
            mode="crownBridge"
            cardData={{ card: card }}
            onChange={(field, value) => handleCardChange(index, field, value)}
            filterToken={filterToken}
          />
        </div>
      ))}

      <div className="my-2 md:my-3 flex px-2">
        <div className="w-[35%] opacity-40 text-sm md:text-md flex items-end">
          Optional
        </div>
        <div className="w-[60%]">
          <button
            type="button"
            onClick={handleAddCard}
            className="bg-[#2fa9bf] text-white px-4 py-1.5 text-sm md:text-md rounded"
          >
            Add another Treatment/Material
          </button>
        </div>
      </div>

      <div className="w-full mt-4">
        <TextInput
          label="Occlusal contact"
          name="occlusalContact"
          value={occlusalContact}
          onChange={(e) => setOcclusalContact(e.target.value)}
          optional
          widthLabel="w-[36.5%] md:w-[31.5%]"
          widthInput="w-[55.5%]"
        />

        <TextInput
          label="Proximal contact"
          name="proximalContact"
          value={proximalContact}
          onChange={(e) => setProximalContact(e.target.value)}
          optional
          widthLabel="w-[36.5%] md:w-[31.5%]"
          widthInput="w-[55.5%]"
        />

        <SelectInput
          label="Pontic design (if any)"
          name="ponticDesign"
          value={ponticDesign}
          onChange={(e) => setPonticDesign(e.target.value)}
          options={[
            { value: "modified", label: "Modified Ridge Lap" },
            { value: "ridge-lap", label: "Saddle Ridge Lap" },
            { value: "hygienic", label: "Hygienic" },
            { value: "conical", label: "Conical" },
            { value: "ovate", label: "Ovate" },
          ]}
          optional
          widthLabel="w-[36.5%] md:w-[31.5%]"
          widthSelect="w-[55.5%]"
        />
      </div>
    </div>
  );
};

export default CrownBridge;
